import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.35 3.84q-.099.317-.1.665c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.3 2.3 0 0 0-.1-.664m-5.8 0a2.25 2.25 0 0 1 2.15-1.586H15a2.25 2.25 0 0 1 2.15 1.586m-5.8 0q-.563.033-1.124.08C9.095 4.015 8.25 4.978 8.25 6.113v2.142m8.9-4.414q.564.033 1.124.08c1.131.094 1.976 1.057 1.976 2.192v10.392a2.25 2.25 0 0 1-2.25 2.25h-2.25m-7.5-10.5H4.875c-.621 0-1.125.503-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125v-1.875m-7.5-10.5h6.375c.621 0 1.125.503 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
    }, null, -1)
  ])))
}
export default { render: render }